export default __webpack_public_path__ + "static/media/3.f696a838.jpg";